import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { ACCESS_ENDED_EVENT } from '../../utils/accessEnded';

// CEV-S3 — full-page notice for a person whose access to HRApp has ended on the leaving date.
export default function AccessEndedGate() {
  const [message, setMessage] = React.useState(null);

  React.useEffect(() => {
    const onEnded = (e) => setMessage(e.detail || 'Your access to HRApp has ended.');
    window.addEventListener(ACCESS_ENDED_EVENT, onEnded);
    return () => window.removeEventListener(ACCESS_ENDED_EVENT, onEnded);
  }, []);

  if (!message) return null;
  return (
    <Box data-testid="access-ended" sx={{
      position: 'fixed', inset: 0, zIndex: 2000, bgcolor: 'background.default',
      display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2,
    }}>
      <Paper elevation={0} sx={{ p: 4, maxWidth: 480, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>{message}</Typography>
        <Typography variant="body2" color="text.secondary">
          If you think this is a mistake, please contact HR.
        </Typography>
      </Paper>
    </Box>
  );
}
